<template>
    <Menu as="div" class="inline-block text-left">
        <div class="">
            <MenuButton
                class="inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
            >
                {{ selected.name }}
                <ChevronDownIcon
                    class="-mr-1 ml-2 h-5 w-5"
                    aria-hidden="true"
                />
            </MenuButton>
        </div>

        <transition
            enter-active-class="transition ease-out duration-100"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition ease-in duration-75"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95"
        >
            <MenuItems
                class="origin-top-left min-h-56 absolute left-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none"
            >
                <div class="py-1">
                    <MenuItem
                        v-for="item in items"
                        :key="item.id"
                        v-slot="{ active }"
                    >
                        <a
                            @click.prevent="handleSelect(item)"
                            href="#"
                            :class="[
                                active
                                    ? 'bg-gray-100 text-gray-900'
                                    : 'text-gray-700',
                                'block px-4 py-2 text-sm',
                            ]"
                            >{{ item.name }}</a
                        >
                    </MenuItem>
                </div>
            </MenuItems>
        </transition>
    </Menu>
</template>

<script setup>
const items = [
    {
        id: 0,
        name: "All",
    }
];


import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { ChevronDownIcon } from "@heroicons/vue/solid";
import {onMounted, ref} from "vue";

const props = defineProps({ filter: Object });
const emit = defineEmits(["apply"]);
const selected = ref({ name: "Select a Status" });

onMounted(() => {
    axios.get("/status?type=external").then(({ data }) => {
        items.push(...data);
    });
});

const handleSelect = (selection) => {
    selected.value = selection;
    emit("apply", Object.assign(props.filter, { value: selected.value.name }));
};
</script>
